import type { ComponentSize } from '@zoryn/constants'

export interface GridRowHeightStore {
  large: number
  default: number
  small: number
  '': number
}

/** 与 ZTable `DEFAULT_ROW_HEIGHT_STORE` 对齐 */
export const DEFAULT_GRID_ROW_HEIGHT_STORE: GridRowHeightStore = {
  large: 56,
  default: 52,
  small: 36,
  '': 52,
}

export function getGridRowHeight(
  size: ComponentSize | undefined | null,
  store: GridRowHeightStore = DEFAULT_GRID_ROW_HEIGHT_STORE,
): number {
  if (size === 'large') return store.large
  if (size === 'small') return store.small
  return store.default
}
